import { useTranslation } from 'react-i18next';
import { AdsChunkSize } from './AdsWithInfiniteScroll.types';
import { AdsSection } from '@/components/AdsSection/AdsSection';
import { ROUTES } from '@/constants/routes';
import type { AdsSectionLayoutScope } from '@/components/AdsSection/AdsSection.types';

interface VipAndLatestAdsSkeletonLoaderProps {
  layoutScope?: AdsSectionLayoutScope;
}

export const VipAndLatestAdsSkeletonLoader = ({
  layoutScope,
}: VipAndLatestAdsSkeletonLoaderProps = {}) => {
  const { t } = useTranslation();

  return (
    <>
      <AdsSection
        title={t('pages.home.vip_ads')}
        adsLoading
        hasPaddingTop
        allAdsLinkData={{ href: ROUTES.ad }}
        layoutScope={layoutScope}
      />
      <AdsSection
        title={t('pages.ads.ads')}
        adsLoading
        chunkSize={AdsChunkSize.Middle}
        layoutScope={layoutScope}
      />
    </>
  );
};
